import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

export const ArrowTopRightAngleIcon: React.FC<IconProps> = ({
  size = 16,
  color = Colors.role.textStrong,
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M5.17157 2.34314L13.6568 2.34314M13.6568 2.34314L13.6568 10.8284M13.6568 2.34314L2.34314 13.6568" stroke={color} strokeLinejoin="round" />
  </Svg>
);

ArrowTopRightAngleIcon.displayName = 'ArrowTopRightAngleIcon';
